
import { FC, useMemo } from 'external/react';
import CourseCover from 'components/CourseCover';
import useAdmin from 'context/admin-context/hook';
import { CourseInfo, CourseMap, Subject, Grade } from 'types/course';


type CoursePreviewProps = {
  hasChanged: boolean
  originalCourse: string
  courseId: string
}

const coursePreviewStyles: (boolean) => React.CSSProperties = (hasChanged) => ({
  display: 'flex', alignItems: 'center', gap: 16,
  background: '#f8fafc', borderRadius: 12,
  padding: '14px 16px', marginBottom: 22,
  border: `1.5px solid ${hasChanged ? '#bae6fd' : '#e2e8f0'}`,
  transition: 'border-color 250ms',
});

const CoursePreview: FC<CoursePreviewProps> = ({ hasChanged, originalCourse, courseId}) => {

  const {state: {courseMap} } = useAdmin();

  const styles = useMemo(() => coursePreviewStyles(hasChanged), [hasChanged])
  const [id, name] = useMemo(() => {

    if (!courseMap) return ["", ""]
    const originalCourseData = courseMap[originalCourse];
    const previewCourseData  = courseMap[courseId];

    const previewId   = courseId   || originalCourse;
    const previewName = previewCourseData?.name ?? originalCourseData?.name ?? originalCourse;

    return [previewId, previewName]
   
  }, [courseMap, courseId, originalCourse])

  return (
    <div style={styles}>
      <div style={{ flexShrink: 0 }}><CourseCover id={id} name={name} /></div>
      <div style={{ minWidth: 0 }}>
      <p style={{ margin: 0, fontSize: 11, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.06em', }}>{hasChanged ? 'Nuevo curso' : 'Curso actual'}</p>
      <p style={{ margin: '3px 0 0', fontSize: 15, fontWeight: 700, color: hasChanged ? '#0ea5e9' : '#1e293b', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',}}>
        {name}
      </p>
      {hasChanged && ( <span style={{ display: 'inline-block', marginTop: 5, fontSize: 10, background: '#e0f2fe', color: '#0369a1', padding: '2px 8px', borderRadius: 999, fontWeight: 700, }}>
        Cambiado
      </span>)}
    </div>
    </div>
    );
};

export default CoursePreview